const routes = {
  exemption: (): string => `exemption`,
  createException: (): string => `/exemption/save`,
  removeException: (): string => `/exemption/inactivate`,
  agregateExceptions: (): string => `/exemption/agreggate`,
};

export default routes;
